import React from 'react';
import { Grid } from '@material-ui/core';

type Props = {
  imageUrl1?: string;
  imageUrl2?: string;
  title?: string;
  copy?: string;
};

export const CareerCollage = ({ imageUrl1, imageUrl2, title, copy }: Props) => {
  return (
    <Grid item sm={12} md={8} className="career-collage">
      <div className="career-collage__content">
        {title && <h5 className="h5 uppercase career-collage__title">{title}</h5>}
        {copy && <div className="body" dangerouslySetInnerHTML={{ __html: copy }}></div>}
      </div>
      <div className="career-collage__medias">
        <div className="career-collage__media media-cover collage-media-1">
          {imageUrl1 && <img src={imageUrl1} alt="Careers at Alo" loading="lazy" />}
        </div>
        <div className="career-collage__media media-cover collage-media-2">
          {imageUrl2 && <img src={imageUrl2} alt="Careers at Alo" loading="lazy" />}
        </div>
      </div>
    </Grid>
  );
};
